<template>
  <v-container fluid class="px-0 py-0 mx-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="image-background white--text">
          <v-card-media height="120px">
          </v-card-media>
          <v-card-actions>
            <v-container fluid class="px-0 py-0 mx-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-tabs grow slider-color="transparent" color="transparent" v-model="tab" slot="extension">
                    <v-tab>
                      <span class="white--text font-600">Entrar</span>
                    </v-tab>
                    <v-tab>
                      <span class="white--text font-600">Registrarse</span>
                    </v-tab>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex x12>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 class="mb-5 pb-4">
                    <v-form v-model="valid" autocomplete="off">
                      <v-text-field label="E-mail" v-model="emailSignIn" required :rules="[() => emailSignIn.length > 0 || 'No hay email']" autocomplete="nope"></v-text-field>
                      <v-text-field label="Contraseña" v-model="passwordSignIn" :append-icon-cb="() => (visibleSignIn = !visibleSignIn)" :append-icon="visibleSignIn ? 'visibility' : 'visibility_off'"
                        :type="visibleSignIn ? 'password' : 'text'" required :rules="[() => passwordSignIn.length > 0 || 'No hay contraseña']"
                        autocomplete="nope"></v-text-field>
                    </v-form>
                    <p class="text-xs-center"><a @click="forgetPassword">¿Has olividado la contraseña?</a></p>
                    <v-btn large block class="caption capitalize font-600" color="primary" @click="signin">Entrar</v-btn>
                  </v-flex>
                  <v-flex xs12 class="mt-5 pt-5">
                    <p class="text-xs-center caption">Al registrar o iniciar sesion aceptas nuestros Terminos y Condiciones y nuestra Politica de privacidad</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-form v-model="valid" autocomplete="off">
                      <v-text-field label="Organización" v-model="organizationSignUp" required :rules="[() => organizationSignUp.length > 0 || 'No hay organización']"
                        autocomplete="nope"></v-text-field>
                      <v-text-field label="Dirección" v-model="addressSignUp" required :rules="[() => addressSignUp.length > 0 || 'No hay dirección']"
                        autocomplete="nope"></v-text-field>
                      <v-text-field label="Nombre Usuario" v-model="usernameSignUp" required :rules="[() => usernameSignUp.length > 0 || 'No hay usuario']"
                        autocomplete="nope"></v-text-field>
                      <v-text-field label="E-mail" v-model="emailSignUp" required :rules="[() => emailSignUp.length > 0 || 'No hay email']" autocomplete="nope"></v-text-field>
                      <v-text-field label="Contraseña" v-model="passwordSignUp" :append-icon-cb="() => (visibleSignUp = !visibleSignUp)" :append-icon="visibleSignUp ? 'visibility' : 'visibility_off'"
                        :type="visibleSignUp ? 'password' : 'text'" required :rules="[() => passwordSignUp.length > 0 || 'No hay contraseña']"
                        autocomplete="nope"></v-text-field>
                    </v-form>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn large block class="caption capitalize font-600" color="primary" @click="signup">Registrarse</v-btn>
                  </v-flex>
                  <v-flex xs12 class="mt-5">
                    <p class="text-xs-center caption">Al registrar o iniciar sesion aceptas nuestros Terminos y Condiciones y nuestra Politica de privacidad</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HTTP from '@/axios-config'

export default {
  name: 'Login',
  data () {
    return {
      emailSignUp: '',
      usernameSignUp: '',
      organizationSignUp: '',
      addressSignUp: '',
      passwordSignUp: '',
      emailSignIn: '',
      passwordSignIn: '',
      valid: true,
      tab: 0,
      visibleSignUp: true,
      visibleSignIn: true
    }
  },
  methods: {
    signup () {
      let requestSignUp = {
        email: this.emailSignUp,
        password: this.passwordSignUp,
        username: this.usernameSignUp,
        organization: this.organizationSignUp,
        address: this.addressSignUp
      }
      HTTP.post('/user/signup', requestSignUp)
        .then(function (response) {
          this.$bus.$emit('event-toast', response.data.message)
          /* if (response.data.result.auth) {
            localStorage.setItem('user', JSON.stringify(response.data.result))
            localStorage.setItem('token', response.data.token)
            HTTP.defaults.headers.common['Authorization'] = response.data.token
            this.$store.dispatch('loginUser', response.data.result).then(() => this.$router.push('/home'))
          } else {
            this.$bus.$emit('event-toast', 'Espere a su autorización por email')
          } */
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    signin () {
      let requestSignIn = {
        email: this.emailSignIn,
        password: this.passwordSignIn
      }
      HTTP.post('/user/signin', requestSignIn)
        .then(function (response) {
          if (response.data.result.auth) {
            localStorage.setItem('user', JSON.stringify(response.data.result))
            localStorage.setItem('token', response.data.token)
            HTTP.defaults.headers.common['Authorization'] = response.data.token
            this.$store.dispatch('loginUser', response.data.result).then(() => this.$router.push('/home'))
          } else {
            this.$bus.$emit('event-toast', 'Espere a su autorización por email')
          }
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    forgetPassword () {
      if (this.emailSignIn === '') return this.$bus.$emit('event-toast', 'Escribe tu correo electrónico en el apartado de email')
      let requestForgetPassword = {
        email: this.emailSignIn
      }
      HTTP.post('/user/forgetPassword', requestForgetPassword)
        .then(function (response) {
          this.$bus.$emit('event-toast', response.data.message)
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    }
  }
}

</script>

<style scoped>
  .image-background {
    background-image: url('./../assets/login_background.jpg') !important;
    background-size: cover !important;
    background-repeat: no-repeat !important
  }

  .btn--active .btn__content:before,
  .btn:hover .btn__content:before,
  .btn:focus .btn__content:before {
    background-color: transparent !important;
  }

  .font-600 {
    font-weight: 600 !important;
  }

  .capitalize {
    text-transform: capitalize !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue